import { FC, useMemo } from 'react';
import { Box, Collapse, List, ListItem, Typography } from '@mui/material';

import UpDownButton from '@components/UpDownButton/UpDownButton';
import useToggle from '@hooks/useToggle';
import { WarningType } from '@interfaces/highRiskSupplements';
import { RiskSupplementWarningType } from '@models/riskSupplementWarningType';
import useWarningTypes from '@store/hooks/useWarningTypes';

import WarningTypeItem from '../WarningTypeItem/WarningTypeItem';

import './style.scss';

interface IProps {
  data: RiskSupplementWarningType;
}

const WarningTypeItemWithAccordion: FC<IProps> = ({ data }): JSX.Element => {
  const { descriptionFragments } = useWarningTypes();

  const [open, , , handleToggle] = useToggle(false);

  const hasDescription = useMemo(
    () =>
      Boolean(
        descriptionFragments.get(data.normalizedName) &&
          descriptionFragments.get(data.normalizedName)?.length,
      ),
    [descriptionFragments, data],
  );

  const descriptionElement = useMemo(() => {
    if (!hasDescription) {
      return null;
    }
    if (data.id !== WarningType.Regulatory) {
      return (
        <Typography className="warning-type-accordion__text">
          {descriptionFragments.get(data.normalizedName)?.join(' ')}
        </Typography>
      );
    }
    return (
      <List className="warning-type-accordion__list">
        {descriptionFragments
          .get(data.normalizedName)
          ?.map(fragment => (
            <ListItem className="warning-type-accordion__list-item">{fragment}</ListItem>
          ))}
      </List>
    );
  }, [descriptionFragments, data, hasDescription]);

  return (
    <Box>
      <Box className="warning-type-accordion__wrapper">
        <WarningTypeItem data={data} iconSize={24} textSize={16} />
        {hasDescription && (
          <Box className="warning-type-accordion__button-wrapper">
            <UpDownButton onOpen={handleToggle} open={open} />
          </Box>
        )}
      </Box>
      {hasDescription && (
        <Collapse in={open} timeout="auto" unmountOnExit>
          {descriptionElement}
        </Collapse>
      )}
    </Box>
  );
};

export default WarningTypeItemWithAccordion;
